import React, { useState, useEffect } from "react";
import { BrowserRouter, NavLink, Route, Routes } from "react-router-dom";
import { FaPhoneAlt, FaBars, FaTimes } from "react-icons/fa";
import Aboutus from "./Aboutus";
import Home from "./Home";
import Property from "./Property";
import Contact from "./Contact";
import Insight from "./Insight";
import WhyUs from "./WhyUs";

const Navbar = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleScroll = () => {
    const currentScrollY = window.scrollY;
    setIsVisible(currentScrollY < lastScrollY);
    setLastScrollY(currentScrollY);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  return (
    <BrowserRouter>
      <div
        className={`font-poppins transition-transform duration-300 ${
          isVisible ? "translate-y-0" : "-translate-y-full"
        } fixed top-0 left-0 w-full z-50`}
      >
        <nav className="bg-white shadow-md px-6 flex justify-between items-center relative py-2">
          {/* Logo */}
          <NavLink to="/">
            <img
              src="/saeedlogo.png"
              alt="Logo"
              className="w-72 h-36 xsm:h-24 xsm:w-40 font-montserrat"
            />
          </NavLink>

          {/* Desktop Nav Links */}
          <ul className="hidden xsm:hidden lg:flex space-x-12 text-lg font-semibold items-center">
            <li><NavLink to="/" end className={({ isActive }) => isActive ? "text-blue-600" : ""}>Home</NavLink></li>
            <li><NavLink to="/Property" end className={({ isActive }) => isActive ? "text-blue-600" : ""}>Property</NavLink></li>
            <li><NavLink to="/Aboutus" className={({ isActive }) => isActive ? "text-blue-600" : ""}>About Us</NavLink></li>
            <li><NavLink to="/Contactus" className={({ isActive }) => isActive ? "text-blue-600" : ""}>Contact Us</NavLink></li>
            <li><NavLink to="/Insight" className={({ isActive }) => isActive ? "text-blue-600" : ""}>Insight</NavLink></li>
            <li><NavLink to="/WhyUs" className={({ isActive }) => isActive ? "text-blue-600" : ""}>Why Us?</NavLink></li>
          </ul>

          {/* Floating Call Button */}
          <a
            href="tel:+971549988814"
            className="hidden lg:flex items-center bg-green-600 px-4 py-2 rounded-xl text-white font-semibold animate-float shadow-md transition-all hover:bg-green-700"
          >
            <FaPhoneAlt className="mr-2 animate-bounce-slow" />
            +971 54 998 8814
          </a>

          {/* Mobile Menu Icon */}
          <div className="lg:hidden">
            <button onClick={toggleMenu} className="text-2xl">
              {isMenuOpen ? <FaTimes /> : <FaBars />}
            </button>
          </div>

          {/* Mobile Menu Dropdown */}
          <div
            className={`absolute top-full left-0 w-full bg-white shadow-lg z-40 transition-all duration-300 ${
              isMenuOpen ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
            } overflow-hidden`}
          >
            <ul className="flex flex-col items-center py-4">
              <li><NavLink to="/" className="py-2 block" onClick={toggleMenu}>Home</NavLink></li>
              <li><NavLink to="/Property" className="py-2 block" onClick={toggleMenu}>Property</NavLink></li>
              <li><NavLink to="/Aboutus" className="py-2 block" onClick={toggleMenu}>About Us</NavLink></li>
              <li><NavLink to="/Contactus" className="py-2 block" onClick={toggleMenu}>Contact Us</NavLink></li>
              <li><NavLink to="/Insight" className="py-2 block" onClick={toggleMenu}>Insight</NavLink></li>
              <li><NavLink to="/WhyUs" className="py-2 block" onClick={toggleMenu}>Why Us?</NavLink></li>
              <a
                href="tel:+971549988814"
                className="mt-2 flex items-center bg-green-600 px-4 py-2 rounded-xl text-white font-semibold"
              >
                <FaPhoneAlt className="mr-2" />
                +971 54 998 8814
              </a>
            </ul>
          </div>
        </nav>
      </div>

      <div className="mt-24">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Aboutus" element={<Aboutus />} />
          <Route path="/Property" element={<Property />} />
          <Route path="/Contactus" element={<Contact />} />
          <Route path="/Insight" element={<Insight />} />
          <Route path="/WhyUs" element={<WhyUs />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
};

export default Navbar;
